<template>
    <div>
        <el-table :data="$parentInfo.Dialog_WorkloadDetail.workloadDetails"
                  border
                  :height="600"
                  :summary-method="getSummaries"
                  show-summary
                  style="width: 100%; margin-top: 20px">
            <el-table-column label="校区" prop="section_name" min-width="3%"></el-table-column>
            <el-table-column label="班级" prop="class_name" min-width="10%"></el-table-column>
            <el-table-column v-for="(item, index) in $parentInfo.Dialog_WorkloadDetail.workloadDetails[0].date_msg" min-width="3%" :key="index">
                <template slot="header" slot-scope="scope">
                    {{item.simple_date}}
                </template>
                <template slot-scope="scope">{{scope.row.date_msg[index].period}}</template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: "Dialog_WorkloadDetail",
        data() {
            return {

            }
        },
        computed: {

        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleInfo();
        },
        methods: {
            handleInfo() {
                this.$parentInfo.Dialog_WorkloadDetail.loading=true;
                this.$wApi.send(this.$parentInfo.path, 'get_workloadDetail', {
                    'month': this.$store.state.modal.data.month,
                    'year':this.$parentInfo.year,
                    'section_ids':this.$parentInfo.section_ids,
                    'teacher_id':this.$store.state.modal.data.teacher_id,
                });
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '汇总';
                        return;
                    }
                    const values = data.map(item => item.date_msg[index-2]);
                    sums[index] = values.reduce((prev, curr) => {
                        if(curr){
                            const value = Number(curr.period);
                            if (!isNaN(value)) {
                                return prev + curr.period;
                            } else {
                                return prev;
                            }
                        }
                    }, 0);
                });

                return sums;
            }
        }
    }
</script>

<style scoped>

</style>